<div *ngIf="value" class="requirements-zone">
    <div class="requirements-list" *ngIf="value.requirements != null && value.requirements.length > 0">

        <shared-managementmodel-requirement-item-component
            *ngFor="let item of value.requirements; let i = index; trackBy: trackByRequirementId" [value]="item"
            [(expanded)]="requirementStates[item.managementModelRequirementId].expanded"
            [(showOpenComments)]="requirementStates[item.managementModelRequirementId].showOpenComments"
            [(showOpenLogs)]="requirementStates[item.managementModelRequirementId].showOpenLogs"
            [(documentOpenedStates)]="requirementStates[item.managementModelRequirementId].documentOpenedStates"
            [(documentItemOpenedStates)]="requirementStates[item.managementModelRequirementId].documentItemOpenedStates"
            (dataRefresh)="onDataRefresh(i, $event)" [order]="i+1" [showorder]="showorder" [readonly]="readonly">
        </shared-managementmodel-requirement-item-component>


        <div *ngIf="useIonic">
            <shared-ionic-managementmodel-requirement-item-component
                *ngFor="let item of value.requirements | sortBy:'requirementOrder'; let i = index" [value]="item"
                (dataRefresh)="onDataRefresh(i, $event)" [order]="i+1" [showorder]="showorder" [readonly]="readonly">
            </shared-ionic-managementmodel-requirement-item-component>
        </div>
    </div>
</div>